<template>
  <div class="procedures-coming-soon-container">
    <ProceduresComingSoonPage />
  </div>
</template>

<script>
import ProceduresComingSoonPage from "@components/ProceduresComingSoonPage/ProceduresComingSoonPage.vue";
export default {
  components: {
    ProceduresComingSoonPage,
  },
};
</script>

<style lang="css" scoped>
.procedures-coming-soon-container {
  width: 100%;
  position: relative;
  top: 15px;
}
</style>
